<template>
  <div class="map-page">
    <div class="content">
      <!-- Map -->
      <div class="map-container column-map left-pos-map">
        <div id="map-main"></div>
        <div class="scrollContorl maplocbtn" @click="panToUserLocation()" title="Get Location"><span><i class="fa fa-compass"></i></span></div>
        <ul class="mapnavigation">
          <li><a href="#" class="direciton-click prevmap-nav" @click="directionClick($event, 'prev')">Prev</a></li>
          <li><a href="#" class="direciton-click nextmap-nav" @click="directionClick($event, 'next')">Next</a></li>
        </ul>
        <div class="scrollContorl mapnavbtn" title="Enable Scrolling"><span><i class="fa fa-lock"></i></span></div>
      </div>
      <div v-if="isMobile()" class="map-mobile-slider">
        <div class="splide" ref="mapMobileSlider" >
          <div class="splide__track">
            <ul class="splide__list">
              <li v-for="store in visibleStores" class="splide__slide" @click="sidebarListingClicked(store)">
                <div class="mobile-listing-card">
                  <span class="spa-name">{{ store.spa_name }}</span>
                  <div class="ratings-area cf">
                    <div class="general-ratings">
                      <span class="rating-id">User Rating</span>
                      <div class="star-ratings-css user-rating">
                        <div class="star-ratings-css-top" :style="'width:'+ (store.ratingAvg) +'%'"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                        <div class="star-ratings-css-bottom"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                      </div>
                    </div>
                    <div class="general-ratings">
                      <span class="rating-id">Google Rating</span>
                      <div class="star-ratings-css google-rating">
                        <div class="star-ratings-css-top" :style="'width:'+ (store.google_rating * 100)/5 +'%'"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                        <div class="star-ratings-css-bottom"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="geodir-category-location">
                    <a :href="'tel:+1'+ store.spa_phone " class="map-item cf"><i class="fa fa-phone" aria-hidden="true"></i> {{ store.spa_phone }}</a>
                    <a :href="'https://maps.google.com/?q='+ store.spa_address " target="_blank" class="map-item cf"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ store.spa_address }}</a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- Map end -->
      <!--col-list-wrap -->
      <div v-if="!isMobile()" class="col-list-wrap right-list" ref="mainWrapperRef">
        <!-- list-main-wrap-->
        <div class="list-main-wrap fl-wrap card-listing">
          <div class="container">
            <!--@foreach($store as $new_store)-->
            <!-- listing-item -->

            <template v-for="store in visibleStores">
              <div v-if="store.in_view === true" class="listing-item">
                <article class="geodir-category-listing fl-wrap">
                  <div v-if="store.photos.length > 50" class="fw-map-carousel fl-wrap full-height lightgallery">
                    <div class="slick-slide-item" v-for="photo in store.photos">
                      <div class="box-item">
                        <img :src="photo.path"   alt="">
                        <a :href="photo.path" class="gal-link popup-image"><i class="fa fa-search"  ></i></a>
                      </div>
                    </div>
                  </div>
                  <div v-else class="geodir-category-img" :style="'background-image: url( /'+store.main_img+') '">
                    <div class="overlay">

                    </div>
                  </div>
                  <div class="geodir-category-content fl-wrap" @click="sidebarListingClicked(store)">
                    <!--<a class="listing-geodir-category" :href="store.store_url_slug">{{ store.store_type }}</a>-->
                    <h3><a :href="'/'+store.region_slug+'/'+store.city_slug+'/'+store.spa_name_slug+'/'">{{ store.spa_name }}</a></h3>
                    <div class="geodir-category-options fl-wrap">
                      <div class="ratings-area cf">
                        <div class="general-ratings">
                          <span class="rating-id">User Rating</span>
                          <div class="star-ratings-css user-rating">
                            <div class="star-ratings-css-top" :style="'width:'+ (store.ratingAvg) +'%'"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                            <div class="star-ratings-css-bottom"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                          </div>
                        </div>
                        <div class="general-ratings">
                          <span class="rating-id">Google Rating</span>
                          <div class="star-ratings-css google-rating">
                            <div class="star-ratings-css-top" :style="'width:'+ (store.google_rating * 100)/5 +'%'"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                            <div class="star-ratings-css-bottom"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                          </div>
                        </div>
                      </div>
                      <div class="geodir-category-location">
                        <a :href="'tel:+1'+ store.spa_phone " class="map-item cf"><i class="fa fa-phone" aria-hidden="true"></i> {{ store.spa_phone }}</a>
                        <a :href="'https://maps.google.com/?q='+ store.spa_address " target="_blank" class="map-item cf"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ store.spa_address }}</a>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </template>
            <!-- listing-item end-->
            <!--@endforeach-->
          </div>
        </div>
        <!-- list-main-wrap end-->
      </div>
      <!--col-list-wrap end -->
      <div class="limit-box fl-wrap"></div>
    </div>
    <!--content end -->
    <div class="limit-box fl-wrap"></div>
    <div class="map-popup-reference-parent" v-show="false" ref='popupContainer'>
      <div class="map-popup-reference" v-if="activeStore">
        <div class="map-popup-wrap">
          <div class="map-popup">
            <div class="infoBox-close" @click="popupClose()">
              <i class="fa fa-times"></i>
            </div>
            <div class="listing-img-content fl-wrap">
              <div v-if="activeStore.photos.length > 0" id="map-inner-carousel" ref="popupSlider" class="fw-map-carousel splide fl-wrap full-height lightgallery">
                <div class="splide__track">
                  <ul class="splide__list"><li v-for="photo in activeStore.photos" class="splide__slide"><img :src="photo" /></li></ul>
                </div>
              </div>
            </div>
            <div class="listing-content fl-wrap">
              <div class="card-popup-raining map-card-rainting" data-staRrating="">
                <span class="map-popup-reviews-count">( {{ activeStore.ratingCount == 1 ? activeStore.ratingCount + ' review' : activeStore.ratingCount + ' reviews' }} )</span>
              </div>
              <div class="listing-title fl-wrap">

                <h4><a :href="'/'+activeStore.region_slug+'/'+activeStore.city_slug+'/'+activeStore.spa_name_slug+'/'">{{ activeStore.spa_name }}</a></h4>
                <a :href="'tel:+1'+ activeStore.spa_phone " class="map-item cf"><i class="fa fa-phone" aria-hidden="true"></i> {{ activeStore.spa_phone }}</a>
                <a :href="'https://maps.google.com/?q='+ activeStore.spa_address " target="_blank" class="map-item cf"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ activeStore.spa_address }}</a>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['locations'],

  data: function() {
    return {
      isActive: undefined,
      storemap: '',
      markers: '',
      marker: [],
      loadedIds: [],
      activeStore: '',
      stores: {},
      visibleStores: {},
      markersArray: [],
      stores_to_get: [],
      zoomCoords: {},
      zoomLevel: '',
      sideHeight: '',
      popupContainer: '',
      tiles: '',
      userLocation: null,
      gettingLocation: false,
      errorStr: null,
      dates: new Date(),
      dayText: '',
      splide_slider: '',
      splide_mobile_slider: undefined,
      splide_mobile_slider_running: false,
      winWidth: $(window).width(),
      popupSliderFirstRun: false,
      mobileSliderFirstRun: false,
    }

  },

  created: function(){
    let _this = this;
    if(!("geolocation" in navigator)) {
      this.errorStr = 'Geolocation is not available.';
      return;
    }
    _this.getUserLocation();
    document.addEventListener("resize", this.getWindowWidth);

  },
  destroyed() {
    document.removeEventListener("resize", this.getWindowWidth);
  },
  mounted() {
    let _this = this;
    _this.popupContainer = _this.$refs.popupContainer;

    this.mainMap();
    //$('.sidebar-listing').height($('.sidebar-listing').outerHeight());
    //this.initSidebar();
    window.onresize = () => {
      this.getWindowWidth();
    }
  },
  computed: {
  },

  methods: {
    mainMap() {
      this.storemap = L.map('map-main');

      this.storemap.on('load', function(){
        setTimeout(() => {
          this.invalidateSize(true);
        }, 800);
      });

      this.storemap.setView([53.5842693, -113.468061], 12);
      this.tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.storemap);

      this.loadMarkers();
      //this.getVisibleMarkers();
      this.storemap.on('moveend zoomend', this.runOnMoveAndZoomEnd);
      // this.storemap.on('moveend', this.runOnMoveEnd());
      // this.storemap.on('zoomend', this.runOnZoomEnd());
    },
    getWindowWidth(e) {
      this.winWidth = document.documentElement.clientWidth;
      if (!this.isMobile() && this.splide_mobile_slider_running) {
          this.splide_mobile_slider.destroy();
          this.splide_mobile_slider_running = false;
      }
    },
    panToUserLocation() {
      this.storemap.panTo([this.userLocation.coords.latitude, this.userLocation.coords.longitude]);
    },
    getUserLocation() {
      this.gettingLocation = true;
      // get position
      navigator.geolocation.getCurrentPosition(pos => {
        this.gettingLocation = false;
        this.userLocation = pos;
        this.panToUserLocation();
      }, err => {
        this.gettingLocation = false;
        this.errorStr = err.message;
      })
    },
    getSingleStore(spa_id) {
      let _this = this;
      return axios.post('/map_path/singlestore/', {spa_id: spa_id})
          .then(response => {
            _this.activeStore = response.data;
          })
          .catch(error => {
            console.log(error)
          });
    },
    loadMarkers() {
      this.markers = L.markerClusterGroup({
        chunkedLoading: true,
        spiderfyOnMaxZoom: true,
      });
      for (var i = 0; i < this.locations.length; i++) {

        this.marker[i] = L.marker(L.latLng(this.locations[i].lat, this.locations[i].lng), {spa_id: this.locations[i].id, loop_id: i}).on('click', this.markerClicked);

        //this.markers.addLayer(this.marker[i]);
        if(this.loadedIds.indexOf(this.locations[i].id) === -1) {
          this.loadedIds.push(this.locations[i].id);
        }
      }

      this.markers.addLayers(this.marker);
      this.storemap.addLayer(this.markers);

    },
    popupClose() {
      this.storemap.closePopup();
    },
    getVisibleMarkers() {
      this.updateZoom();
      let _this = this;
      let current_marker = {};
      let stores_to_get = [];
      _this.markers.eachLayer(function (layer) {
        if (_this.storemap.getBounds().contains(layer.getLatLng())) {
          current_marker = {};
          current_marker.id = layer.options.spa_id;
          current_marker.fetched = false;
          _this.markersArray.push(current_marker);
        }
      });
      _this.markersArray.forEach(function (store){
        if (store.fetched === false) {
          stores_to_get.push(store.id);
        }
      });
      axios.post('/map_path/getmultiplestores/', {stores: stores_to_get})
          .then(response => {
            response.data.map(function (value, index) {
              if (typeof _this.stores[value.id] !== 'object') {
                Vue.set(_this.stores, value.id, value)
                _this.stores[value.id].in_view = true;
              }
            });
          })
          .catch(error => {
            console.log(error)
          });
    },
    listingClicked(spa_id, lat, lng) {
      this.isActive = spa_id;
      this.storemap.setView([lat, lng], 18);
      //this.markers.zoomToShowLayer(this.marker[spa_id])
    },
    markerClicked(marker_id) {
      let _this = this;
      let spa_obj = '';
      if (marker_id.target) {
        spa_obj = marker_id.target;
      } else {
        spa_obj = marker_id;
      }
      if (typeof _this.stores[spa_obj.options.spa_id] === 'object') {
        _this.activeStore = _this.stores[spa_obj.options.spa_id];
      } else {
        this.getSingleStore(spa_obj.options.spa_id);
      }
      setTimeout(() => {
        _this.marker[spa_obj.options.loop_id].bindPopup(_this.popupContainer,
            {closeButton: false}
        )
        if (this.activeStore.photos.length > 0) {
          _this.listingSlides();
        }
        _this.popupContainer.style.display = 'block';
        _this.marker[spa_obj.options.loop_id].openPopup();
      }, 200);
    },
    directionClick(e, direction) {
      e.preventDefault();
      if (typeof (this.isActive) == "undefined") {
        let store_index = direction === 'next' ? 0 : (this.marker.length - 1);
        this.listingClicked(store_index, this.marker[store_index]._latlng.lat, this.marker[store_index]._latlng.lng);
        this.markerClicked(this.marker[store_index]);
      } else {
        let new_index = '';
        if(direction === 'next') {
          if (this.isActive + 1 < this.marker.length) {
            new_index = this.isActive + 1;
          } else {
            new_index = 0;
          }
        } else {
          if (this.isActive === 0) {
            new_index = (this.marker.length - 1);
          } else {
            new_index = this.isActive - 1;
          }
        }
        this.listingClicked(new_index, this.marker[new_index]._latlng.lat, this.marker[new_index]._latlng.lng);
        this.markerClicked(this.marker[new_index]);
        this.markers.zoomToShowLayer(this.marker[new_index]);
      }
    },
    logVisibleClusters() {
      let _this = this;
      let clusters = [];
      _this.stores_to_get = [];
      _this.storemap.eachLayer((l) => {
        if( l instanceof L.Marker && _this.storemap.getBounds().contains(l.getLatLng()) )
          clusters.push(l);
        _this.stores_to_get.push(l.options.spa_id);
      })
      _this.visibleStores = {};
      axios.post('/map_path/getmultiplestores/', {stores: _this.stores_to_get})
          .then(response => {
            response.data.map(function (value, index) {
              if (typeof _this.visibleStores[value.id] !== 'object') {
                Vue.set(_this.visibleStores, value.id, value)
                _this.visibleStores[value.id].in_view = true;
              }
            });
          })
          .catch(error => {
            console.log(error)
          });
    },
    sidebarListingClicked(store) {
      let loop_object = this.marker.find(obj => {
        return obj.options.spa_id === store.id
      })
      this.markerClicked(loop_object);
      this.listingClicked(store.id, store.lat, store.lng);
    },
    updateZoom(){
      this.zoomLevel = this.storemap.getZoom();
    },
    loadStoresInView(bounds) {
      this.updateZoom();
      let _this = this;
      if (_this.stores.length <= 6071) {
        this.zoomCoords.neLat = bounds.target.getBounds()._northEast.lat;
        this.zoomCoords.neLng = bounds.target.getBounds()._northEast.lng;
        this.zoomCoords.swLat = bounds.target.getBounds()._southWest.lat;
        this.zoomCoords.swLng = bounds.target.getBounds()._southWest.lng;

        axios.post('/map_path/mapzoom/', {coords: this.zoomCoords, loaded_ids: this.loadedIds})
            .then(response => {

              //this.stores = {...this.stores, ...response.data };
              //this.stores = response.data;
              response.data.map(function (value, index) {
                if (_this.loadedIds.indexOf(value.id) === -1) {
                  _this.stores.push(value);
                }
              });
              //this.loadMarkers();
              //this.resizeAndReload();
            })
            .catch(error => {
              console.log(error)
            });
      }
    },
    initSidebar() {
      let _this = this;
      if (window.innerWidth >= 1030) {

      }
    },

    resizeAndReload() {
      this.sideHeight = this.$refs.sidebarListing.clientHeight;

      if (this.winWidth > 768) {
        console.log('gtrater');
        $('.sidebar-listing').height(this.sideHeight);
      }
      this.mapSlyelement.obj.reload();
      console.log('resizing');
    },
    pluck(array, key) {
      return array.map(function(obj) {
        return obj[key];
      });
    },
    isMobile() {
      if(this.winWidth < 1030) {
        return true
      } else {
        return false
      }
    },
    listingSlides() {
      let _this = this;
      //console.log('first run is '+_this.popupSliderFirstRun)
      setTimeout(() => {
        if (_this.popupSliderFirstRun === false) {
          _this.splide_slider = new Splide( _this.$refs.popupSlider, {
            type     : 'loop',
            height   : '10rem',
            focus    : 'center',
            autoWidth: true,
          } );
          _this.splide_slider.mount();
          _this.popupSliderFirstRun = true;
        } else {
          _this.splide_slider.refresh();
        }
      }, 400);
    },
    mobileSlides() {
      let _this = this;
      setTimeout(() => {
        if (_this.mobileSliderFirstRun === false) {
          _this.initMobileSlider();
        } else {
          if (!_this.splide_mobile_slider_running) {
            _this.initMobileSlider();
          } else {
            _this.splide_mobile_slider.refresh();
            _this.splide_mobile_slider_running = true;
          }
        }
      }, 200);
    },
    initMobileSlider() {
      let _this = this;
      _this.splide_mobile_slider = new Splide( _this.$refs.mapMobileSlider, {
        type     : 'loop',
        height   : '10rem',
        omitEnd: true,
        mediaQuery: 'min',
        clones: 0,
        breakpoints: {
          768: {
            perPage: 2,
          },
        },
        padding: { left: '1rem', right: '1rem' }

      });
      _this.splide_mobile_slider.mount();
      _this.mobileSliderFirstRun = true;
      _this.splide_mobile_slider_running = true;
    },
    runOnZoomEnd() {
      console.log('running zoom end');
    },
    runOnMoveEnd() {
      console.log('running move end');
    },
    runOnMoveAndZoomEnd() {
      this.logVisibleClusters();
      if (this.isMobile()) {
        this.mobileSlides();
      }
    },
    getTodayHours (hours){
      switch(this.dates.getDay()) {
        case 0:
          this.dayText = 'Sunday';
          break;
        case 1:
          this.dayText = 'Monday';
          break;
        case 2:
          this.dayText = 'Tuesday';
          break;
        case 3:
          this.dayText = 'Wednesday';
          break;
        case 4:
          this.dayText = 'Thursday';
          break;
        case 5:
          this.dayText = 'Friday';
          break;
        case 6:
          this.dayText = 'Saturday';
          break;
        default:
          // code block
      }
      if (hours) {
        if (typeof hours == 'string') {
          hours = hours.split(',');
        }
        for (var i = 0; i < hours.length; i++) {
          if (hours[i].includes(this.dayText)) {
            var today_hours = hours[i].replace('["', '' );
            return today_hours;
          }
        }
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MapView.vue